import React from 'react';
import SubPageHeader from '../../components/common/SubPageHeader';

const Articles = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* 1. Standard Header */}
      <SubPageHeader title="Article" />

      {/* 2. Main Content Section with Beach Background */}
      <div className="relative py-20 px-4 min-h-screen flex justify-center items-center">
        {/* The background ocean image mimicking your screenshot */}
        {/* <div className="absolute inset-0 z-0 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=2000" 
            alt="scenic beach" 
            className="w-full h-full object-cover opacity-80"
          />
        </div> */}

        {/* 3. The Article "Page" Card */}
        <div className="relative z-10 max-w-4xl w-full bg-white shadow-2xl border-[4px] border-[#003366] rounded-sm p-8 md:p-16">
          
          {/* Header Area */}
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-serif text-[#032167] tracking-widest uppercase">Article</h2>
            <div className="w-12 h-[2px] bg-amber-400 mx-auto mt-2"></div>
            
            <h1 className="text-xl md:text-2xl font-bold text-[#032167] mt-10 uppercase tracking-tighter">
              YOGIC WAY OF LIFE
            </h1>
            <p className="italic font-serif text-[#032167] mt-2 font-bold uppercase">Old is Gold</p>
          </div>

          {/* Article Body Text */}
          <div className="space-y-8 text-gray-800 leading-relaxed font-medium  text-justify md:text-left">
            <p>
              Over the years we are realizing the detrimental effects of so called man made progress in technology. 
              Medicine, modern fertilizers for crops and sustainable living.
            </p>

            <p>
              Let us deliberate about modern medicine for humans as well as agriculture sector.
            </p>

            <p>
              It is a proven fact that modern medicine dominated by the pharma sector has largely failed to cure many diseases. 
              There has been an ongoing hot debate by many Ayurveda researchers including Swami Ramdev of Patanjali, 
              who claim to cure many diseases completely, which the modern medicine does not have an answer to.
            </p>

            <p>
              The best way to live a healthy disease free life / a medicine free life is to embrace the yogic way of living. 
              Yogic way of living does not mean that you should go to the Himalayas and live as a sanyasi.
            </p>

            <p>
              Everyone should study properly the eight point agenda or sub topics of Ashtanga yoga as advocated by 
              the great Maharshi Patanjali thousands of years ago.
            </p>

            <p>
              As a matter of caution, learn from an authentic source for a total understanding of ashtanga yoga. 
              Studying and practicing some fragments or parts of the ashtanga yoga will not be appropriate to live, a 
              healthy and peaceful life in the true sense of the words.
            </p>

            <p>
              Unless and until you pursue a particular sports the perpetual way to live healthy is the practice of 
              Pranayam, Asanas, Ayurveda for curing ailments and the practice of MUDRAS? again an ancient treasure 
              forgotten by the modern world.
            </p>

            <p>
              Old is gold only if we are able to discover it. A mass awakening about these ancient practices has to be 
              created all over the globe to save this beautiful planet and human lives.
            </p>

            <p>
              Right from the school age when the sub-conscious mind is being registered, the basics of Ayurveda, 
              ashtang yoga and Mudrabhyas should be taught to the students. There is no short cut to health or 
              rather anything in life which is sustainable and durable.
            </p>

            <p>
              Therefore every branch of all disciplines in all the schools and colleges across the globe should have 
              a subject teaching the basics of Living a healthy medicine free life i.e. Ayurveda, Ashtanga yoga and 
              Mudrabhyas to every student.
            </p>

            <p className="pt-10 border-t border-gray-100 font-bold not-italic text-[#032167]">
              Let us live 2022 by following the principles of AYURVEDA, studying Patanjali ASHTANG YOGA & 
              practising the ancient treasure of MUDRAS!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;